/**
 * Analytics Utilities
 * Cookie-aware analytics tracking
 */

'use client';

let analyticsEnabled = false;

/**
 * Initialize analytics with cookie consent
 */
export function initializeAnalytics(hasConsent: boolean) {
  analyticsEnabled = hasConsent;
  
  if (hasConsent && typeof window !== 'undefined') {
    // Initialize Google Analytics or other analytics services
    console.log('Analytics initialized');
  }
}

/**
 * Track page view
 */
export function trackPageView(url: string) {
  if (!analyticsEnabled) return;
  
  // Implement page view tracking
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', 'GA_MEASUREMENT_ID', {
      page_path: url,
    });
  }
}

/**
 * Track search event
 */
export function trackSearch(query: string, mode: 'FSA' | 'HSA') {
  if (!analyticsEnabled) return;
  
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'search', {
      search_term: query,
      search_mode: mode,
    });
  }
}

/**
 * Track result view
 */
export function trackResultView(
  query: string,
  classification: string,
  confidence: number
) {
  if (!analyticsEnabled) return;
  
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'view_result', {
      query,
      classification,
      confidence,
    });
  }
}

/**
 * Track submission
 */
export function trackSubmission() {
  if (!analyticsEnabled) return;
  
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'community_submission');
  }
}

/**
 * Track newsletter signup
 */
export function trackNewsletterSignup(cadence?: string) {
  if (!analyticsEnabled) return;
  
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'newsletter_signup', {
      cadence,
    });
  }
}

/**
 * Track surprise me click
 */
export function trackSurpriseMe() {
  if (!analyticsEnabled) return;
  
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'surprise_me_click');
  }
}

/**
 * Enable analytics (after cookie consent)
 */
export function enableAnalytics() {
  analyticsEnabled = true;
  console.log('Analytics enabled');
}

/**
 * Disable analytics (cookie opt-out)
 */
export function disableAnalytics() {
  analyticsEnabled = false;
  console.log('Analytics disabled');
}

